import type { SVGProps } from "react";

export function IconBlackFastTime(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.1822 5.1956C40.5645 3.69034 34.713 5.41883 29.8145 9.31125C25.9276 12.3999 22.6117 16.8685 20.4251 22.25H3.25V23.75H19.8536C19.5202 24.6858 19.2205 25.6464 18.9571 26.6295C18.5423 28.1774 18.2335 29.7218 18.0258 31.25H11.25V32.75H12H28H28.75V34.25H28H17.7455C17.6411 36.3073 17.7209 38.3184 17.9729 40.25H3.25V41.75H18.2059C18.5431 43.6153 19.0452 45.3947 19.7007 47.0564C21.9968 52.8765 26.2001 57.2992 31.8178 58.8045C37.4355 60.3097 43.287 58.5813 48.1855 54.6888C53.0841 50.7963 57.0759 44.7118 59.043 37.3705C61.0101 30.0292 60.5954 22.7641 58.2993 16.9437C56.0033 11.1235 51.8 6.70086 46.1822 5.1956ZM44.0597 16.0148L43.8656 16.7393L38.9543 35.0685L42.9628 40.2066L43.4241 40.7979L42.2415 41.7206L41.7801 41.1292L37.5418 35.6965L37.312 35.402L37.4087 35.0411L42.4167 16.351L42.6108 15.6266L44.0597 16.0148Z"
        fill="#23232C"
      />
    </svg>
  );
}
